import { render, staticRenderFns } from "./ApplicantChangePassword.vue?vue&type=template&id=40dbac5e&scoped=true&"
import script from "../../services/applicant/applicant-change-password.js?vue&type=script&lang=js&"
export * from "../../services/applicant/applicant-change-password.js?vue&type=script&lang=js&"
import style0 from "./ApplicantChangePassword.vue?vue&type=style&index=0&id=40dbac5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dbac5e",
  null
  
)

export default component.exports